export const environment = {
    production: false,
    url: 'https://apiv2-iheal-staging.stacknize.com/cc/',
}